<template>
  <div id="app" :class="[isEmulating ? 'emulating' : '']">
      <div v-html="menuMobileHtml"  class="primary-mobile-menu"></div>
    <header v-html="headerHtml" id="header" class="d-print-none"></header>
    <TopBar class="top-bar" v-if="user" :user="user" :isEmulating="isEmulating" />
    <div class="main-content container-fluid">
      <div class="arvc-basicblock">
        <main role="main">
          <router-view v-if="user" />
          <h6 v-else><a :href="loginURL">Loading... Please wait...</a> <b-icon icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon></h6>
        </main>
      </div>
    </div>
    <footer v-html="footerHtml" class="d-print-none"></footer>
  </div>
</template>

<script>
import axios from 'axios';
// eslint-disable-next-line import/no-extraneous-dependencies
import cheerio from 'cheerio';

// @ is an alias to /src
import TopBar from '@/components/TopBar.vue';

axios.defaults.withCredentials = true;

const server = `${process.env.VUE_APP_API_URL}`;
const loginURL = `${server}/login`;
const website = `${process.env.VUE_APP_WP_WEBSITE_URL}`;

export default {
  name: 'App',
  components: {
    TopBar,
  },
  data() {
    return {
      loginURL,
      loadingMessage: 'Loading... Please Wait...',
      user: null,
      isEmulating: false,
      menuMobileHtml: null,
      headerHtml: null,
      footerHtml: null,
    };
  },
  async beforeCreate() {
    console.log('Getting header');
    const globalElemRes = await axios.get(`${website}/blank`, { withCredentials: false });
    const $b = cheerio.load(globalElemRes.data);
    const $header = $b('header');
    const $footer = $b('footer');
    const $menuMobile = $b('.primary-mobile-menu');

    // eslint-disable-next-line func-names
    $b('a', $header).each(function () {
      const $this = $b(this);
      if ($this.attr('href').startsWith('/')) {
        $this.attr('href', `${website}${$b(this).attr('href')}`);
      }
      if ($this.attr('href').startsWith('https://portal.arvc')) {
        const splitUrl = $this.attr('href').split('/');
        $this.attr('href', `/${splitUrl.slice(3).join('/')}`);
      }
      if ($this.attr('href').includes('Join-ARVC')) {
        $this.css('display', 'none');
      }
    });
    // eslint-disable-next-line func-names
    $b('a', $footer).each(function () {
      const $this = $b(this);
      if ($this.attr('href').startsWith('/')) {
        $this.attr('href', `${website}${$b(this).attr('href')}`);
      }
    });
    // // eslint-disable-next-line func-names
    // $b('img', $header).each(function () {
    //   $b(this).attr('src', `${website}/${$b(this).attr('src')}`);
    // });
    // // eslint-disable-next-line func-names
    // $b('img', $footer).each(function () {
    //   $b(this).attr('src', `${website}/${$b(this).attr('src')}`);
    // });

    this.headerHtml = $header.html();
    this.footerHtml = $footer.html();
    this.menuMobileHtml = $menuMobile.html();
  },
  mounted() {
    this.$nextTick(async () => {
      if (localStorage.getItem('postLogin')) {
        const redirU = localStorage.getItem('postLogin');
        localStorage.removeItem('postLogin');
        window.location.href = redirU;
      }
      setTimeout(async () => {
        try {
          const rawContact = await axios.get(`${server}/api/contact`);
          if (rawContact.data.redirect) {
            localStorage.setItem('postLogin', window.location.href);
            // eslint-disable-next-line no-restricted-globals
            location.href = `${rawContact.data.redirect}?r=${location.href}`;
          } else if (rawContact.data) {
            const myContact = rawContact.data;
            this.user = {
              contactId: myContact.Id,
              email: myContact.Email,
              membership: myContact.FS_Membership_Type1__c,
              name: `${myContact.FirstName} ${myContact.LastName}`,
              badges: myContact.OrderApi__Badges__c,
            };
            this.isEmulating = myContact.isEmulating;
            localStorage.setItem('arvcportal_user', JSON.stringify(this.user));
          } else {
            this.loadingMessage = 'There was an issue logging you in. Please let us know so we can investigate!';
          }
        } catch (err) {
          console.log({ contactError: err });
        }
      }, 1000);
    });
  },
};
</script>

<style lang="scss">
  main {
    padding-top: 135px;
    padding-bottom: 45px;
  }
  .header .layout-container {
    padding-top: 36px;
  }
  #arvc-benefits-bar .exclude-portal {
    display: none;
  }
  @media print {
    html body main.col-md-9 {
      width: 100% !important;
      margin-left: 0px !important;
    }
  }
  .emulating .top-bar {
    position: absolute;
    top: 140px;
  }
  .emulating .main-content {
    margin-top: 30px;
  }
</style>
